import { Component } from '@angular/core';
import { SuraButtonComponent, ButtonConfig } from '@sura-ui/atoms';

@Component({
  selector: 'app-final-test',
  standalone: true,
  imports: [SuraButtonComponent],
  template: `
    <div style="padding: 40px; background: linear-gradient(135deg, #4CAF50, #45a049); color: white; text-align: center; min-height: 100vh;">
      <h1 style="font-size: 3em; margin-bottom: 20px;">🎉 ÉXITO TOTAL</h1>
      <h2>La librería unificada funciona perfectamente</h2>
      <div style="background: rgba(255,255,255,0.1); padding: 20px; border-radius: 10px; margin: 20px auto; max-width: 500px;">
        <p>Componente cargado desde:</p>
        <code style="background: rgba(0,0,0,0.2); padding: 10px; border-radius: 5px; display: block; margin: 10px 0;">
          &#64;sura-ui/atoms
        </code>
        <div style="margin: 20px 0;">
          <sura-button [config]="buttonConfig" (buttonClick)="onButtonClick($event)"></sura-button>
        </div>
      </div>
      <div style="background: rgba(255,255,255,0.1); padding: 20px; border-radius: 10px; margin: 20px auto; max-width: 600px;">
        <h3>✅ Verificación exitosa:</h3>
        <ul style="text-align: left; display: inline-block;">
          <li>✅ Librería unificada funciona</li>
          <li>✅ TypeScript resuelve los tipos</li>
          <li>✅ Componente renderiza correctamente</li>
          <li>✅ API simplificada sin hexagonal</li>
        </ul>
      </div>
      <p style="margin-top: 30px;">🎯 La refactorización está completamente implementada</p>
    </div>
  `
})
export class FinalTestComponent {
  
  // Configuración del botón usando la nueva interfaz ButtonConfig
  buttonConfig: ButtonConfig = {
    id: 'test-button',
    label: '🎉 Librería Unificada Exitosa',
    variant: 'primary',
    size: 'medium',
    disabled: false,
    loading: false
  };

  constructor() {
    console.log('🎉 LIBRERÍA UNIFICADA EXITOSA');
    console.log('✅ SuraButtonComponent cargado desde @sura-ui/atoms:', SuraButtonComponent);
    console.log('✅ Configuración del botón:', this.buttonConfig);
  }

  onButtonClick(event: any) {
    console.log('🔥 ¡Botón clickeado! La librería unificada funciona al 100%', event);
  }
}